module.exports = __webpack_public_path__ + "img/collection-engagementRingsClassic.f1ed7b4.jpg";